export const paths = {
  launch: '/',
  home: '/home',
  bible: '/bible',
  hymnal: '/hymnal',
  events: '/events',
  news: '/news',
  forum: '/forum',
  forumDetails: (forumId: string) => `/forum/${encodeURIComponent(forumId)}`,
  forumDetailsRoute: '/forum/:forumId',
  forumPostDetail: (forumId: string, postId: string) =>
    `/forum/${encodeURIComponent(forumId)}/post/${encodeURIComponent(postId)}`,
  forumPostDetailRoute: '/forum/:forumId/post/:postId',
  ministries: '/ministries',
  departmentDetails: (departmentId: string) => `/forum/department/${encodeURIComponent(departmentId)}`,
  departmentDetailsRoute: '/forum/department/:departmentId',
  donation: '/donation',
  givingHistory: '/giving/history',
  media: '/media',
  mediaDetail: (bookId: string) => `/media/${encodeURIComponent(bookId)}`,
  mediaDetailRoute: '/media/:bookId',
  mediaCart: '/media/cart',
  mediaCheckoutCallback: '/media/checkout/callback',
  mediaLibrary: '/media/library',
  mediaLibraryDetail: (bookId: string) => `/media/library/${encodeURIComponent(bookId)}`,
  mediaLibraryDetailRoute: '/media/library/:bookId',
  mediaReader: (bookId: string) => `/media/library/${encodeURIComponent(bookId)}/read`,
  mediaReaderRoute: '/media/library/:bookId/read',
  mediaOrders: '/media/orders',
  mediaOrderDetail: (orderId: string) => `/media/orders/${encodeURIComponent(orderId)}`,
  mediaOrderDetailRoute: '/media/orders/:orderId',
  church: '/church',
  churchBrowse: '/church/browse',
  churchDocuments: '/church/documents',
  churchEvents: '/church/events',
  churchRegistrationReview: '/church-registration/review',
  churchRegistrationReviewWithToken: (token: string) =>
    `/church-registration/review/${encodeURIComponent(token)}`,
  churchRegistrationReviewTokenRoute: '/church-registration/review/:token',
  churchLeadership: (type: string) => `/church/leadership/${encodeURIComponent(type)}`,
  churchLeadershipRoute: '/church/leadership/:type',
  family: '/family',
  familyInvite: '/family/invite',
  familyMembers: '/family/members',
  familyRequests: '/family/requests',
  resources: '/resources',
  resourceCart: '/resources/cart',
  resourceOrders: '/resources/orders',
  resourceOrderDetail: (orderId: string) => `/resources/orders/${encodeURIComponent(orderId)}`,
  resourceOrderDetailRoute: '/resources/orders/:orderId',
  resourceCheckoutCallback: '/resources/checkout/callback',
  convention: '/convention',
  conventionAnnouncementDetail: '/convention/announcement',
  conventionRegistration: '/convention/registration',
  conventionProgramDetails: '/convention/program',
  conventionPublicationPayment: '/convention/publication/payment',
  conventionMyRegistrations: '/convention/registrations',
  conventionMyPublications: '/convention/publications',
  discipleship: '/discipleship',
  wallet: '/wallet',
  walletWithdraw: '/wallet/withdraw',
  walletTransactions: (walletNumber: string) =>
    `/wallet/${encodeURIComponent(walletNumber)}/transactions`,
  walletTransactionsRoute: '/wallet/:walletNumber/transactions',
  walletTransactionDetails: (walletNumber: string, transactionId: string) =>
    `/wallet/${encodeURIComponent(walletNumber)}/transactions/${encodeURIComponent(transactionId)}`,
  walletTransactionDetailsRoute: '/wallet/:walletNumber/transactions/:transactionId',
  walletFundingCallback: '/wallet/funding/callback',
  givingCallback: '/giving/callback',
  profile: '/profile',
  settings: '/settings',
  devotional: '/devotional',
  devotionalDetail: (id: string) => `/devotional/${encodeURIComponent(id)}`,
  devotionalDetailRoute: '/devotional/:id',
  sundaySchool: '/sunday-school',
  notifications: '/notifications',
  login: '/auth/login',
  googleRedirect: '/auth/google/callback',
  emailVerify: '/auth/email-verify',
  register: '/auth/register',
  registerVerification: '/auth/email/verify',
  forgotPassword: '/auth/forgot-password',
  verifyOtp: '/auth/verify-otp',
  resetPassword: '/auth/reset-password',
} as const;
